/**
 * Top Bar 1
 */
(() => {
  const socials = document.querySelector('.topbar-1 .socials');
  document.querySelectorAll('.social > a')
    .forEach((link) => {
      if (socials) {
        socials.append(link.cloneNode(true));
      }
    });

  const quickOrderWrapper = document.querySelector('.topbar-1 .quick-order-wrapper');
  const quickOrder = document.querySelector('header .header-full .quickordertoggle');
  if (quickOrderWrapper && quickOrder) {
    quickOrderWrapper.append(quickOrder);
  }

  const quickListWrapper = document.querySelector('.topbar-1 .quick-list-wrapper');
  const quickList = document.querySelector('header .header-full .vuequicklistdropdown_elem');
  if (quickListWrapper && quickList) {
    quickListWrapper.replaceWith(quickList);
  }
})();
